module.exports = __webpack_public_path__ + "img/green_pin.55e50ae8.png";